import {useDispatch, useSelector} from 'react-redux';
import {useAuth} from '../../../hooks/useAuth';
import {selectShowKeys, toggleKeys} from '../../../store/slices/translationToggleSlice';
import {Switch} from '../../basic/switch';
import {Label} from '../../basic/label';
import {useTranslation} from 'react-i18next';
import {config} from '../../../config';

export default function TranslationToggle() {
    const {user} = useAuth();
    const showKeys = useSelector(selectShowKeys);
    const dispatch = useDispatch();
    const {t} = useTranslation();

    const isPlatformAdmin = user?.roles?.includes('PLATFORM_ADMIN');

    if (!isPlatformAdmin || !config.trackI18nKeys) {
        return null;
    }

    return (
        <div className="fixed top-16 right-4 z-50 bg-card border rounded-lg shadow-lg p-3">
            <div className="flex items-center gap-3">
                <Switch
                    id="translation-toggle"
                    checked={showKeys}
                    onCheckedChange={() => dispatch(toggleKeys())}
                />
                <Label htmlFor="translation-toggle" className="cursor-pointer">
                    {showKeys ? t('translationToggle.hideKeys') : t('translationToggle.showKeys')}
                </Label>
            </div>
        </div>
    );
}
